import { formatDate, formatAmount } from '@/util/helpers'

export default function () {
  return {
    formatDate,
    formatAmount,
    fab: false,
    plan: {},
  }
}
